import { StoreState } from '@/redux/types';
import { getUserId } from './getUserId';

export function getIsLoggedIn(state: StoreState) {
  return Boolean(getUserId(state));
}
